import React, { useState } from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';
import StringProcessingService from '../../services/string-processing-service';
import ConfigurationService from '../../services/configuration-service';

import {
    BrowserRouter as Router,
    withRouter,
} from "react-router-dom";


function Info(props) {
    if (props.handleOnMarkerHover) return (props.handleOnMarkerHover(props.data))
    else return null;
}

function handleOnClick(props) {
    let {data, selectionId, agentId, history, soldOutMarker = false, currentPage } = props;

    const languagePrefix = ConfigurationService.getCurrentLanguagePrefix();
    if(!soldOutMarker || data.units_total!==data.units_sold){
        switch (currentPage) {
            case 'SelectionListingPage': 
            case 'ProjectOfferPage': 
            case 'SelectionPage': {
                let path = '';
                if(data.offerId){
                    path = `/${languagePrefix}/selection/${selectionId}/offer/${data.offerId}`
                    history.push({
                        pathname: path,
                    })
                }else{
                    if (agentId !== undefined && agentId !== null) path = `/${languagePrefix}/selection/${selectionId}/${agentId}/listing/${data.id}`;
                    else path = `/${languagePrefix}/selection/${selectionId}/listing/${data.id}`
                    history.push({
                        pathname: path,
                    })
                }
                break;
            }
            case 'ConstructionLobbyPage':
            case 'ProjectInnerPage':
            case 'StandAloneGalleryPage':
            case 'ArticleInnerPage':{
                history.push({
                    pathname: `/${languagePrefix}/projects/${data.id}/${StringProcessingService.StringFormatUrl(data.name)}`,
                })
                break;
            }
           
            default: {
                history.push({
                    pathname: `/${languagePrefix}/listing/${data.id}`,
                })
                break;
            }
        }
    }
}

function CustomMarker(props) {
    let { position,currentSelectionListing, data,key, selectionId, agentId, similarOffers,secondaryMarker = false,soldOutMarker=false,hoveredMarkerId,currentPage} = props;
    const [isVisibleInfo, setVisibleInfo] = useState(false);
    const [isHover, setIsHover] = useState(false);


    let markerName = '';
    if(secondaryMarker || currentPage==='SelectionPage'|| currentPage==='SearchPage' ){
        markerName = 'smartluxe-map-pointer-small.png';
    }else if(soldOutMarker){
        markerName = 'smartluxe-map-pointer-small-sold-out.png';
    }else{
        markerName = 'smlx_marker_a.png'
    }

    if(currentSelectionListing != null && ((currentSelectionListing.ListingId!=null &&(currentSelectionListing.ListingId!==data.id)) ||
    (currentSelectionListing.id != null && currentSelectionListing.id !== data.id))){
        markerName = 'smartluxe-map-pointer-small.png'
    }


    if(isHover || hoveredMarkerId === data.id){
        markerName = 'smlx_marker_a.png'
    }

    let icon = {
        url: `https://ngirealty.com/resource/data/${markerName}`,
    }
    
    return (
        <Marker
            key={key}
            tracksViewChanges={false}
            icon={icon}
            onMouseOver={(event) => {
                if (currentPage === 'ProjectInnerPage' || currentPage === 'ConstructionLobbyPage' || currentPage === 'StandAloneGalleryPage' || currentPage === 'ArticleInnerPage' ||
                    currentPage === 'SearchPage') {
                    setVisibleInfo(true)
                }
                
                setIsHover(true)
                document.dispatchEvent(new CustomEvent('markerHover', { detail: { id: data.id } }))
            }}
            onMouseOut={() => {
                if (currentPage === 'ProjectInnerPage' || currentPage === 'ConstructionLobbyPage' || currentPage === 'StandAloneGalleryPage' || currentPage === 'ArticleInnerPage' ||
                    currentPage === 'SearchPage') setVisibleInfo(false)
                setIsHover(false)
                document.dispatchEvent(new CustomEvent('markerHover', { detail: { id: null } }))
                
            }}
            onClick={() => { handleOnClick(props) }}
            position={position}>
            {(isVisibleInfo || hoveredMarkerId === data.id) && (currentPage === 'ProjectInnerPage' || currentPage === 'ConstructionLobbyPage' || currentPage === 'ConstructionLobbyPage' || currentPage==='SearchPage') ? ( //isVisibleInfo
                <InfoWindow
                    key={key}
                    position={position}
                    onCloseClick={() => { setVisibleInfo(false) }}
                >
                    {Info(props)}
                </InfoWindow>
            ) : null}
        </Marker>
    )
}

export default withRouter(CustomMarker);